<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        v-if="visible"
        class="dialog-overlay"
        @click="handleOverlayClick"
      ></div>
    </transition>

    <!-- 弹窗 -->
    <transition name="pop">
      <div v-if="visible" class="dialog-container">
        <div class="dialog-content" @click.stop>
          <!-- 关闭按钮 -->
          <button class="close-btn" @click="close">
            <img src="../../../assets/shop/pop/close.png" alt="" />
          </button>
          <!-- 奖品表格 -->
          <div class="dialog-body">
            <el-table
              :data="rewardData"
              stripe
              style="width: 100%"
              size="small"
              class="rewardTable"
            >
              <el-table-column
                prop="remark"
                :label="$t('rewardDialog.reward1')"
              >
                <template slot-scope="scope">
                  <img
                    v-for="(item, index) in scope.row.remark"
                    :key="index"
                    :src="require(`../../../assets/shop/reward/${item}.png`)"
                    alt=""
                    class="remark-img"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="reduce_point"
                :label="$t('rewardDialog.reward4')"
              ></el-table-column>
              <el-table-column prop="point" :label="$t('rewardDialog.reward2')">
              </el-table-column>
              <el-table-column
                prop="add_time"
                :label="$t('rewardDialog.reward3')"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "RewardDialog",
  data() {
    return {
      visible: false,
      rewardData: [],
    };
  },
  methods: {
    /**
     * 打开弹窗
     */
    open(rewardData) {
      this.visible = true;
      // 处理remark字段，将数字转为奖品名称
      let data = JSON.parse(JSON.stringify(rewardData));
      data.forEach((item) => {
        let remarkArr = [];
        try {
          remarkArr = JSON.parse(item.remark).num;
          item.reduce_point = JSON.parse(item.remark).reduce_point;
          // 转换奖品名称
          // const nameMap = {
          //   7: this.$t("shop.coin"),
          //   8: this.$t("shop.fruit"),
          //   9: this.$t("shop.diamond"),
          // };
          // item.remark = remarkArr.map((num) => nameMap[num] || num).join(", ");
        } catch (e) {
          remarkArr = [];
        }

        item.remark = JSON.parse(item.remark).num;
        console.log(item.remark);
      });
      this.rewardData = data;
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.visible = false;
    },
    /**
     * 处理遮罩层点击
     */
    handleOverlayClick() {
      // 如果需要点击遮罩层关闭弹窗，取消注释下一行
      // this.close();
    },
  },
};
</script>

<style scoped lang="scss">
// 遮罩层
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

// 弹窗容器
.dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

// 弹窗内容
.dialog-content {
  background-image: url(../../../assets/shop/pop/reward_bg.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 30vw;
  height: 38vw;
  position: relative;
  padding: 9vw 2vw 2vw 1.5vw;
  box-sizing: border-box;
}

// 关闭按钮
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:hover {
    transform: scale(1.1);
  }
}

// 标题
.dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

// 内容
.dialog-body {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  height: 27vw;
  overflow: auto;

  :deep(.el-table) {
    background-color: transparent;

    .el-table__header-wrapper {
      background-color: rgba(255, 255, 255, 0.9);
    }

    .el-table__body {
      background-color: rgba(255, 255, 255, 0.8);
    }

    th {
      background-color: rgba(240, 240, 240, 0.95);
      color: #333;
      font-weight: bold;
    }

    td {
      border-bottom-color: rgba(224, 224, 224, 0.5);
    }
  }
}

// 弹出动画
.pop-enter-active {
  animation: popIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pop-leave-active {
  animation: popOut 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
  from {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes popOut {
  from {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.rewardTable {
  height: 100;
}

.remark-img{
  width: 30px;
  height: 30px;
}

@media (max-width: 1024px) {
  .dialog-content {
    width: 93vw;
    height: 125vw;
    padding: 30vw 7vw 10vw 5vw;
  }
  .dialog-body {
    height: 84vw;
  }
  .remark-img{
  width: 20px;
  height: 20px;
}
}
</style>

